<script lang="ts">
  import Slider from "./Slider.svelte";
  import type { SliderItem } from "./type";
  import checkMobileDevice from "../common/is-mobile";

  export let isImageReady: boolean = false;

  const sliderItems: SliderItem[] = [
    {
      id: "item_1",
      icon: "splash-excel",
      iconWidth: "30px",
      iconHeight: "30px",
      title: "Excel against any source",
      descriptions:
        "Work within a familiar interface where you can spend your time focusing on solving real business issues at hand.",
      descriptionMaxWidth: 650,
      image: "/images/splash/splash-excel.png",
    },
    {
      id: "item_2",
      icon: "splash-analysis",
      iconWidth: "30px",
      iconHeight: "30px",
      title: "Powerful Analysis",
      descriptions:
        "Build sophisticated queries to explore and analyze your data. Search and AI/ML models built-in. Seriously.",
      descriptionMaxWidth: 650,
      image: "/images/splash/splash-powerful-analysis.png",
    },
    {
      id: "item_3",
      icon: "splash-dashboard",
      iconWidth: "54px",
      iconHeight: "45px",
      title: "Beautiful Dashboards",
      descriptions:
        "Create intuitive dashboards with our drag-and-drop interface. Or completely customize the dashboard experience. Up to you.",
      descriptionMaxWidth: 700,
      image: "/images/splash/splash-beautiful-dashboards.png",
    },
  ];
  const isMobile = checkMobileDevice();
</script>

<!-- only show the slider when the image has been fetch -->
{#if isImageReady}
  <div class="splash-container" class:mobile={isMobile}>
    <Slider items={sliderItems} />
  </div>
{/if}

<style lang="postcss">
  .splash-container {
    position: relative;
    display: grid;
    place-items: center;
    min-height: 100%;
    z-index: 10;
    padding: 40px 0px 56px;
    overflow: hidden;
  }

  .splash-container.mobile {
    padding-bottom: 36px;
  }
</style>
